import { useEffect, useRef } from "react";
import axios from "axios";
import { useAuth, useClerk } from "@clerk/react";
import { API } from "@/lib/api";

const KEY = "etm-remember";

export async function logout(signOut) {
  const token = localStorage.getItem(KEY);
  localStorage.removeItem(KEY);
  if (token) await axios.post(`${API}/auth/forget`, { token }).catch(() => {});
  await signOut({ redirectUrl: "/" });
}

export const StaySignedIn = () => {
  const { isLoaded, isSignedIn } = useAuth();
  const clerk = useClerk();
  const busy = useRef(false);
  useEffect(() => {
    const token = localStorage.getItem(KEY);
    if (!isLoaded || isSignedIn || !token || busy.current) return;
    busy.current = true;
    axios.post(`${API}/auth/resume`, { token })
      .then(async ({ data }) => {
        const si = await clerk.client.signIn.create({ strategy: "ticket", ticket: data.ticket });
        await clerk.setActive({ session: si.createdSessionId });
      })
      .catch((e) => { if (e?.response?.status === 401) localStorage.removeItem(KEY); })
      .finally(() => { busy.current = false; });
  }, [isLoaded, isSignedIn, clerk]);
  return null;
};
